export class ImageMetaData {
  naturalWidth: number;
  naturalHeight: number;

  constructor(init?: Partial<ImageMetaData>) {
    Object.assign(this, init);
  }

  
}
